import React from 'react';
import PropTypes from 'prop-types';
import isRTL from '../../utils/is-rtl';

export default class Direction extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  state = {
    isRTLEnabled: isRTL(),
  };

  componentDidMount() {
    const { isRTLEnabled } = this.state;
    this.setDirection(isRTLEnabled);
  }

  setDirection(isRTLEnabled) {
    const dir = isRTLEnabled ? 'rtl' : 'ltr';
    document.documentElement.setAttribute('dir', dir);
  }

  render() {
    return this.props.children;
  }
}
